import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BusAuctionFilterService } from '../../../home/services/bus-auction-filter.service';
import { AuctionFilter } from '../../../home/models/auction-filter';
import { DataTableDirective } from 'angular-datatables';

const apiServer = environment.apiServer;
const apiControl = '/HistoryMailing';

declare var $: any;

@Component({
  selector: 'app-history-mailing-page',
  templateUrl: './history-mailing-page.component.html',
  styleUrls: ['./history-mailing-page.component.sass']
})
export class HistoryMailingPageComponent implements OnInit {
  dataSetExportImportTable: any;
  dtOptionsExportImportTable: DataTables.Settings = {};
  dataSetRegions: any;
  checkedRegion: string[];
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  spinner: NgxSpinnerService;

  dt: DataTables.Api;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private _spinner: NgxSpinnerService) {
    this.dataSetExportImportTable = [];
    this.checkedRegion = [];
    this.spinner = _spinner;
  }

  ngOnInit() {
    this.spinner.show();

    this.modelAuctionFilter.participant = { value: "all", name: "Все" };

    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 245px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        // dataTablesParameters.regionName = this.modelAuctionFilter.region;
        // dataTablesParameters.customerName = this.modelAuctionFilter.contractor;
        // dataTablesParameters.Mnn = this.modelAuctionFilter.mnn;
        // dataTablesParameters.SumFrom = this.modelAuctionFilter.sumFrom;
        // dataTablesParameters.SumTo = this.modelAuctionFilter.sumTo;
        // dataTablesParameters.dtFrom = this.modelAuctionFilter.dateAucFrom;
        // dataTablesParameters.dtTo = this.modelAuctionFilter.dateAucTo;
        // dataTablesParameters.status = this.modelAuctionFilter.statusItem.value;
        // dataTablesParameters.addSign = this.modelAuctionFilter.addSign;
        // dataTablesParameters.participant = this.modelAuctionFilter.participant.value;
        dataTablesParameters.search = this.modelAuctionFilter.search;

        this.http.post<any>(apiServer + apiControl, dataTablesParameters, {})
          .subscribe(resp => {
            if (resp != null) {
              this.dataSetRegions = resp.data;
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            }
            this.spinner.hide();
          });
      },
      order: [[0, "asc"]],
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          targets: 2
        },
      ],
    };
  }

  afterNgFor() {
    $('#exportImportTable').DataTable().columns.adjust();
    $('[data-toggle="popover"]').popover();
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
    
  }

  mailtext(date, item){
    if(item != null){
      var modal = $('#messageModal');
      modal.find('.mailBody').text(item.replace(/br/g, "\r\n"));
      modal.find('.modal-title').text("Отправлено " + date);
      modal.show();
    }
  }

  onFieldChange(): void {
    this.dt.ajax.reload();
    this.dataSetExportImportTable = [];
    this.spinner.show();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/component/history-mailing-page/history-mailing-page.component.ts